module.exports = __webpack_public_path__ + "img/wnw_header.7bb44ea5.png";